import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';

import { LogoutFlowInitiated } from '@troyai/auth/data-access';
import { GreetingCardComponent } from '@troyai/auth/feature';

@Component({
  imports: [GreetingCardComponent],
  templateUrl: './access-denied-shell.component.html',
})
export class AccessDeniedShellComponent {
  private store = inject(Store);

  loginWithRedirect(): void {
    this.store.dispatch(new LogoutFlowInitiated());
  }
}
